import { ServerResponseStatus } from "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { map } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
class EntityDownloadClientStrategy {
  constructor(_mapper, _service, _entityType, _mappingKeys) {
    this._mapper = _mapper;
    this._service = _service;
    this._entityType = _entityType;
    this._mappingKeys = _mappingKeys;
  }
  process(request) {
    if (request.hasSummary && !this._mappingKeys.summaryQueryFields) {
      throw new Error("SummaryQueryFields mapping key is not provided to download strategy");
    }
    const queryFields = request.keys?.map((k) => this._mapper.map(k, this._mappingKeys.viewModelKeys, this._mappingKeys.queryFields)) ?? [];
    const summaryQueryFields = request.hasSummary ? request.keys?.map(
      (k) => this._mapper.map(k, this._mappingKeys.viewModelKeys, this._mappingKeys.summaryQueryFields)
    ) ?? [] : [];
    return this._service.get({ type: this._entityType, fields: [...queryFields, ...summaryQueryFields].filter((f) => f), filter: request.filter }).pipe(
      map((response) => {
        const items = this.filterItems(response?.responsePayload?.items);
        let result = { status: "Failed", mode: "client" };
        if (response.status === ServerResponseStatus.Success) {
          result = {
            status: "Success",
            items: items.map((i) => this._mapper.map(i, this._mappingKeys.model, this._mappingKeys.downloadModel)),
            mode: "client"
          };
        }
        return result;
      })
    );
  }
  filterItems(items) {
    return items;
  }
}
export {
  EntityDownloadClientStrategy
};
//# sourceMappingURL=strategy.js.map
